import React from 'react';
import cx from 'classnames';

import Button from '../Button';

import styles from './TextInput.module.scss';
import usePresenter from './TextInput.presenter';
import getProps from './TextInput.props';
import { TextInputCombinedProps } from './types';

// MANUAL OVERRIDE - converted to forwardRef
const TextInput = React.forwardRef<HTMLInputElement, TextInputCombinedProps>((props, ref) => {
  const {
    type,
    error,
    size,
    className,
    classes,
    textValue,
    textPlaceholder,
    onTextChanged,
    button,
    dataTestId, // MANUAL OVERRIDE
    htmlType, // MANUAL OVERRIDE
    disabled, // MANUAL OVERRIDE
    onKeyDown, // MANUAL OVERRIDE
  } = usePresenter(props);

  const variantName = `${type}${error}${size}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`textInput${variantName}`];

  const [inputValue, setInputValue] = React.useState<string>('');

  React.useEffect(() => {
    setInputValue(textValue || '');
  }, [textValue]);

  const onInputChanged = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setInputValue(event.target.value);
    if (onTextChanged) {
      onTextChanged(event.target.value);
    }
  };

  let componentView;

  switch (variantName) {
    case 'TextCenteredNoneS':
    case 'TextNoneM':
    case 'TextCenteredErrorS':
    case 'TextErrorM':
    case 'TextNoBGNoneM':
    case 'TextNoBGNoneS': {
      componentView = (
        <div
          className={cx(currentStyle, className)}>
          <input
            ref={ref} // MANUAL OVERRIDE
            className={cx(styles.input, classes?.input)}
            data-testid={dataTestId} // MANUAL OVERRIDE
            type={htmlType} // MANUAL OVERRIDE
            disabled={disabled} // MANUAL OVERRIDE
            placeholder={textPlaceholder}
            value={inputValue}
            onChange={onInputChanged} 
            onKeyDown={onKeyDown} // MANUAL OVERRIDE
          />
        </div>
      );
      break;
    }
    case 'TextIconNoneM':
    case 'TextIconErrorM': {
      componentView = (
        <div
          className={cx(currentStyle, className)}>
          <input
            ref={ref} // MANUAL OVERRIDE
            className={cx(styles.input, classes?.input)}
            data-testid={dataTestId} // MANUAL OVERRIDE
            type={htmlType} // MANUAL OVERRIDE
            disabled={disabled} // MANUAL OVERRIDE
            placeholder={textPlaceholder}
            value={inputValue}
            onChange={onInputChanged}
            onKeyDown={onKeyDown} // MANUAL OVERRIDE
          />
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}
            buttonType="button" // MANUAL OVERRIDE
            disabled={disabled} // MANUAL OVERRIDE
            size='S' // MANUAL OVERRIDE
            type='FieldIcon' // MANUAL OVERRIDE
          />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
});

export default TextInput;
